import { Component, EventEmitter, OnChanges, Input, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { EcmsStatus } from '../../types/ecms-status';
import { EcmsEntry } from '../../types/ecms-entry'


@Component({
  selector: 'upload-ecms',
  templateUrl: './upload-ecms.component.html',
  styleUrls: ['./upload-ecms.component.css'],
  providers: [HubService],
})

export class UploadECMSComponent implements OnInit, OnChanges {
  public failFlag: boolean;

  ecmsStatusList = <EcmsStatus[]>[];
  errorMessage: string;

  newECMS = new EcmsEntry;


  isDisabled: boolean;
  isUploading: boolean;

  @Output() open_close = new EventEmitter<boolean>();
  @Input() inMprnList: string;

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.isDisabled = false;
    this.isUploading = false
    this.failFlag = false;
    this.newECMS.mprn = this.inMprnList.toString();

    this.hubService.getLookupTable('ecms_status').subscribe(
      lookup_values => this.ecmsStatusList = <EcmsStatus[]>lookup_values,
      error => this.errorMessage = <any>error,
    );

  }

  ngOnChanges(changes: SimpleChanges) { }

  sendFlag() {
    this.open_close.emit(false);
  }

  upload() {
    this.newECMS.hub_batch = +this.newECMS.hub_batch;
    this.newECMS.ei_batch = +this.newECMS.ei_batch;

    if (this.newECMS.date_sent != undefined) {
      var tempDate = new Date(this.newECMS.date_sent);
      this.newECMS.date_sent = tempDate;
    }

    console.log(this.newECMS);

    this.isDisabled = true;
    this.isUploading = true;
    this.hubService.uploadECMS(this.newECMS)
      .subscribe(
        data => {
          this.isUploading = false;
          if (data.status != "success") {
            this.failFlag = true;
          } else {
            this.sendFlag();
          }
        },
        error => {
          console.log(error);
          this.isUploading = false;
          this.failFlag = true;
        }
      );
  }

  cancel() {
    this.sendFlag();
  }
}
